<template>
  <section>
    <b-field grouped group-multiline>
      <b-field>
        <p class="control">
          <span class="button is-static">
            {{ $t('attributes.activation_status') }}
          </span>
        </p>
        <b-select v-model="filterStatus" @input="onFilterStatus">
          <option value="X">{{ $t('attributes.all') }}</option>
          <option value="Y">{{ $t('attributes.shelve_on') }}</option>
          <option value="N">{{ $t('attributes.shelve_off') }}</option>
        </b-select>
      </b-field>
      <b-field>
        <b-button
          :loading="sending"
          class="is-primary"
          icon-left="plus"
          @click="onAdd"
        >
          {{
            $t('attributes.add') +
              $t('attributes.honey_moon_page') +
              $t('attributes.top_banner')
          }}
        </b-button>
      </b-field>
    </b-field>
    <b-table
      :data="honeyMoonTopBanners"
      :loading="loading"
      :mobile-cards="false"
      narrowed
      bordered
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        width="75"
        sortable
        numeric
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>
      <b-table-column
        field="status"
        :label="$t('attributes.activation_status')"
        width="75"
        sortable
        centered
        v-slot="props"
      >
        <b-tag
          :type="props.row.status === 'Y' ? 'is-info' : 'is-danger'"
          size="is-medium"
        >
          {{ props.row.status === 'Y' ? '上架' : '下架' }}
        </b-tag>
      </b-table-column>
      <b-table-column
        :label="$t('attributes.picture')"
        width="120"
        centered
        v-slot="props"
      >
        <a
          v-if="props.row.picture"
          :href="projectImageUrl(props.row.picture)"
          @click.prevent="onClickImage(props.row.mobile_picture)"
        >
          <figure class="image">
            <img
              :src="projectImageUrl(props.row.picture)"
              :alt="$t('attributes.picture')"
              style="width: 120px; margin: auto;"
            />
          </figure>
        </a>
      </b-table-column>
      <b-table-column
        :label="$t('attributes.mobile_picture')"
        width="100"
        centered
        v-slot="props"
      >
        <a
          v-if="props.row.mobile_picture"
          :href="projectImageUrl(props.row.mobile_picture)"
          @click.prevent="onClickImage(props.row.mobile_picture)"
        >
          <figure class="image">
            <img
              :src="projectImageUrl(props.row.mobile_picture)"
              :alt="$t('attributes.picture')"
              style="width: 64px; margin: auto;"
            />
          </figure>
        </a>
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        field="has_video"
        :label="$t('attributes.has_video')"
        width="140"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.has_video === 'Y' ? '是' : '否' }}
      </b-table-column>
      <b-table-column
        field="url"
        :label="$t('attributes.url')"
        width="120"
        centered
        v-slot="props"
      >
        <a v-if="props.row.url" :href="props.row.url" target="_blank">
          {{ props.row.has_video === 'Y' ? '影片連結' : '外連' }}
        </a>
      </b-table-column>
      <b-table-column width="165" label="功能" centered v-slot="props">
        <b-button type="is-info" @click.prevent="onModify(props.row)">
          {{ $t('attributes.modify') }}
        </b-button>
      </b-table-column>
    </b-table>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
    <b-modal :active.sync="isModalActive" has-modal-card>
      <honey-moon-top-banner-form
        :banner="selectedBanner"
        :isCreate="isCreate"
        @send="onSend"
      ></honey-moon-top-banner-form>
    </b-modal>
  </section>
</template>

<script>
import debounce from 'lodash/debounce'
import { HONEY_MOON_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import HoneyMoonTopBannerForm from '@/components/company/HoneyMoonTopBannerForm'

export default {
  name: 'HoneyMoonTopBannerList',
  components: { HoneyMoonTopBannerForm },
  data() {
    return {
      sending: false,
      loading: false,
      filterStatus: 'X',
      honeyMoonTopBanners: [],

      selectedBanner: [],
      isModalActive: false,
      isCreate: false,

      isImageModalActive: false,
      selectedImageUrl: ''
    }
  },
  mounted() {
    this.loadHoneyMoonTopBanners(this.filterStatus)
  },
  methods: {
    async loadHoneyMoonTopBanners(status) {
      this.loading = true
      const api = `${HONEY_MOON_API}/${status}/top_banner`
      try {
        const res = await this.axios.get(api)
        this.honeyMoonTopBanners = res.data.data
        this.loading = false
      } catch (e) {
        this.loading = false
        this.honeyMoonTopBanners = []
        notifyService.fetch_error('country', e)
      }
    },
    onModify(item) {
      this.selectedBanner = item
      this.isCreate = false
      this.isModalActive = true
    },
    onAdd() {
      this.selectedBanner = {
        id: '',
        sort: 1,
        status: 'Y',
        name: '',
        picture: '',
        mobile_picture: '',
        has_video: 'N',
        url: ''
      }
      this.isCreate = true
      this.isModalActive = true
    },
    onSend(item) {
      if (this.isCreate) {
        this.onCreate(item)
      } else {
        this.onUpdate(item)
      }
    },
    async onUpdate(item) {
      const api = `${HONEY_MOON_API}/update/top_banner`
      try {
        this.sending = true
        await this.axios.put(api, item)
        notifyService.success(this.$t('attributes.update_succeed'))
        await this.loadHoneyMoonTopBanners(this.filterStatus)
        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async onCreate(item) {
      const api = `${HONEY_MOON_API}/create/top_banner`
      try {
        this.sending = true
        await this.axios.post(api, item)
        await this.loadHoneyMoonTopBanners(this.filterStatus)
        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = this.projectImageUrl(url)
    },
    onFilterStatus: debounce(function() {
      this.loadHoneyMoonTopBanners(this.filterStatus)
    }, 500)
  }
}
</script>
